import { Component, HostBinding, OnInit, ViewChild } from '@angular/core';
import { ToolRequestsService } from '@app/core/services/tool-requests.service';
import { TableConfig } from "@app/shared/util/table-config.utils";
import { ActivatedRoute, Router } from "@angular/router";
import { ToolRequest } from "@app/shared/models/toolRequests.model";
import { ToolSet } from "@app/tool/model/toolSet.model";
import { Tool } from "@app/tool/model/tool.model";
import { ConfirmationModalComponent } from "@components/confirmation-modal/confirmation-modal.component";
import { ToastsManager } from "@app/shared/util/toastr.service";
import { TranslateService } from "@ngx-translate/core";
import { Log } from "ng2-logger";
import { Location } from "@angular/common";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { ResolutionService } from "@services/resolution.service";
import { LogoutModalComponent } from "@app/shared/components";

@UntilDestroy()
@Component({
    selector: 'app-incoming-tool-requests-detail',
    templateUrl: './incoming-tool-requests-detail.component.html',
    styleUrls: ['./incoming-tool-requests-detail.component.scss']
})
export class IncomingToolRequestsDetailComponent implements OnInit {
    _logger = Log.create(IncomingToolRequestsDetailComponent.name);

    @ViewChild(ConfirmationModalComponent, {static: true}) confirmationModal: ConfirmationModalComponent;
    @ViewChild(LogoutModalComponent, {static: false}) logoutModal: LogoutModalComponent;

    selectedToolRequest: ToolRequest = new ToolRequest();
    selectedTools: Array<Tool | ToolSet> = [];
    tableConfig = new TableConfig();
    isConfirmationInProgress = false;
    isLoading = false;

    type: string;
    @HostBinding('class.mobile') isMobile = false;

    constructor(private toolRequestService: ToolRequestsService,
                private activatedRoute: ActivatedRoute,
                private toaster: ToastsManager,
                private router: Router,
                private translateService: TranslateService,
                private resolutionService: ResolutionService,
                private location: Location) {

        this.resolutionService.screenSize$.pipe(untilDestroyed(this)).subscribe(screen => {
            this.isMobile = screen.mobile;
        })
    }

    ngOnInit() {
        this.activatedRoute.params.subscribe(params => {
            const id = +params['id'];
            this.isLoading = true;
            this.tableConfig.pager.pageSize = -1;
            this.tableConfig.upsertFilter("dontShowToolsAtLine", true);
            this.toolRequestService.getToolRequestTools(id, this.tableConfig).subscribe(
                tools => {
                    const toolsThatAreNotAtLine = [];
                    tools.items.forEach((tool: Tool | ToolSet) => {
                        if (tool instanceof Tool && !tool.isAlreadyReservedForLine) {
                            toolsThatAreNotAtLine.push(tool);
                        }
                        if (tool instanceof ToolSet) {
                            tool.tools = tool.tools.filter(toolFromSet => !toolFromSet.isAlreadyReservedForLine)
                            if (tool.tools.length !== 0) {
                                toolsThatAreNotAtLine.push(tool)
                            }
                        }
                    });
                    this.selectedTools = toolsThatAreNotAtLine;
                    this.isLoading = false;
                });
            this.toolRequestService.getToolRequestDetails(id).subscribe(
                toolRequest => {
                    this.selectedToolRequest = toolRequest;
                }
            );
        });
        this.activatedRoute.data.subscribe(value => {
            this.type = value['type'];
        })

    }

    onProcessToolRequest() {
        if (this.selectedToolRequest) {
            this.confirmationModal.open();
        }
    }

    onBack() {
        this.location.back();
    }

    onConfirmProcess(event) {
        if (this.isConfirmationInProgress) {
            return;
        }
        this._logger.info('onConfirmProcess:: Processing tool request', event);
        this.isConfirmationInProgress = true;
        const boschId = this.isMobile ? null : event.boschId;
        this.toolRequestService.processById(this.selectedToolRequest.id, boschId).subscribe(
            data => {
                this._logger.info('onConfirmProcess:: API returned data', data);
                this.toaster.success(this.buildProcessMessage(this.selectedToolRequest.name));
                this.isConfirmationInProgress = false;
                this.confirmationModal.close();

                if (this.isMobile) {
                    this.logoutModal.open();
                } else {
                    this.navigateToRoot();
                }
            },
            error => {
                this._logger.error('onConfirmProcess:: API returned error', error);
                this.isConfirmationInProgress = false;
            }
        );
    }


    onInvalidBadge(event) {
        this._logger.info('onInvalidBadge::', event);
    }

    getPartNumberName() {
        if (this.selectedToolRequest.partNumber) {
            return this.selectedToolRequest.partNumber.name;
        }
        return this.translateService.instant('atom.tool-requests-lines.process.labels.noPartNumber');
    }

    buildProcessMessage(toolRequestName) {
        return this.translateService.instant('lift-operator.incoming-tool-request.toasts.processed',
            {toolRequestName: toolRequestName});
    }

    onContinue() {
        this.navigateToRoot();
    }

    private navigateToRoot() {
        this.router.navigate(['/incoming-tool-requests/' + this.type]).then();
    }
}
